module.exports = __webpack_public_path__ + "static/analytics-f581f8ead029b2bff3497c9552f502a0.jpg";